import { ckewrapPlugin } from './plugin'

export const initCkewrapPlugin = () => {
  if (CKEDITOR.plugins.get('ckewrap')) {
    return
  }

  CKEDITOR.plugins.add('ckewrap', ckewrapPlugin)
}
